import { render } from "./UsersList.vue?vue&type=template&id=2caf1b1e&scoped=true&ts=true"
import script from "./UsersList.vue?vue&type=script&lang=ts"
export * from "./UsersList.vue?vue&type=script&lang=ts"

import "./UsersList.vue?vue&type=style&index=0&id=2caf1b1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2caf1b1e"]])

export default __exports__